import React, { Component } from 'react';
import Swal from "sweetalert2";
import { getValueCookie } from '../services/cookieService';
import { getInformationWithData } from '../services/CABE';
import "../css/inventory-style.css"
import "../css/general-style.css"
import '../css/table-responsive.css'
import { getIndexElement } from '../functions/searchInObject';
import { pricesFormat } from '../functions/pricesFormat';
import { ItemDesc, NumberFormat, OrderArray } from '../functions/generalFunctions';
import LoadingWindow from '../components/LoadingWindow';
import { BsFileArrowUpFill, BsFileArrowDownFill } from "react-icons/bs";
import SmallModal from '../components/SmallModal';
import { Menu } from "../components/Menu/Menu";

export default class ItemPriceExeption extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }
    state = {
        Products: [],
        ProductsFilter: [],
        TableHeaders: [],
        AuxTableHeaders: [],
        PricesLevels: [{ name: 'All', Level: '0' }],
        flag: true,
        minwidth: '200',
        addItemModal: false,

        pageNumers: [],
        ProductsPerPage: 70,
        lastIndex: 70,
        firstIndex: 0,
        textFilter: '',
        ExcludedItems: [] // Product list excluding the already added in the exception list
    }

    componentDidMount(){
        this.getProductsMargin()
    }

    async getProductsMargin() {
        this.ModalLoading.current.showState(true);
        const data = {
            idCompany: Number(getValueCookie('CompanyId')),
            type: 'CalculatePriceMargins',
        }
        
        const result = await getInformationWithData('/Items/margin', data)
        if (result.status.code === 1) {
            // Extract current exception items
            const exceptionItems = this.extractItems(result.result)
            this.loadExceptionItems(exceptionItems)
        }
        this.ModalLoading.current.showState(false);
    }
    
    async loadExceptionItems(items) {
        let temporal = []
        let PricesLevels = [{ name: 'All', Level: '0' }]
        console.log('loadExceptionItems', items )
        for (const item of items) {
            const index = getIndexElement(temporal, 'ItemCode', item.ItemCode)
            if (index === -1) {
                const it = {
                    ItemCode: item.ItemCode,
                    ItemCodeDesc: item.ItemCodeDesc,
                    ProductLine: item.ProductLineDesc,
                    UnitCost: item.LastTotalUnitCost,
                    Change: false,
                    PricesLevels: []

                }
                const priceLev = {
                    PriceLevel: item.CustomerPriceLevel,
                    LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                    RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                    NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.DiscountMarkup1,
                    NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : ((Number(item.DiscountMarkup1) - Number(item.LastTotalUnitCost)) / (Number(item.DiscountMarkup1))) * 100,

                }
                it.PricesLevels.push(priceLev)
                temporal.push(it)
            } else {
                const priceLev = {
                    PriceLevel: item.CustomerPriceLevel,
                    LevelCost: item.DiscountMarkup1 === 0 ? '-' : item.DiscountMarkup1,
                    RealMargin: item.DiscountMarkup1 === 0 ? '-' : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                    NewLevelCost: item.DiscountMarkup1 === 0 ? 0 : item.DiscountMarkup1,
                    NewRealMargin: item.DiscountMarkup1 === 0 ? 0 : ((Number(item.DiscountMarkup1) - Number(temporal[index].UnitCost)) / (Number(item.DiscountMarkup1))) * 100,
                }
                temporal[index].PricesLevels.push(priceLev)
            }
        }
        let headers = []
        for (const item of temporal) {
            for (const pricelevel of item.PricesLevels) {
                const index = getIndexElement(headers, 'Level', pricelevel.PriceLevel)
                const index2 = getIndexElement(PricesLevels, 'Level', pricelevel.PriceLevel)
                if (index === -1) {
                    const head = {
                        Level: pricelevel.PriceLevel,
                        Title1: "Level " + pricelevel.PriceLevel,
                        Title2: "Real Mark-Up Level " + pricelevel.PriceLevel,
                        Title3: "New Level " + pricelevel.PriceLevel,
                        Title4: "New Real Mark-Up Level " + pricelevel.PriceLevel,
                    }
                    headers.push(head)
                }
                if (index2 === -1) {
                    PricesLevels.push({ name: 'Price Level ' + pricelevel.PriceLevel, Level: String(pricelevel.PriceLevel) })
                }
            }


        }
        for (const item of temporal) {
            if (item.PricesLevels.length !== headers.length) {
                for (const head of headers) {
                    const index = getIndexElement(item.PricesLevels, 'PriceLevel', head.Level)
                    if (index === -1) {
                        const priceLev = {
                            PriceLevel: head.Level,
                            LevelCost: '-',
                            RealMargin: '-',
                            NewLevelCost: 0,
                            NewRealMargin: 0
                        }
                        item.PricesLevels.push(priceLev)
                    }
                }
            }
        }
        temporal = await ItemDesc(temporal, 'ItemCodeDesc', 'ItemCode')
        this.setState({ Products: temporal, ProductsFilter: temporal.slice(this.state.firstIndex, this.state.lastIndex), TableHeaders: headers, PricesLevels: PricesLevels, AuxTableHeaders: headers, minwidth: (headers.length * 120) + 'vh',textFilter:'' })
        // document.getElementById("CheckChangeMarginPrice0").checked = true;
        // this.checkFilter("CheckChangeMarginPrice0", { name: 'All', Level: '0' })
        console.log('temporal', temporal)
        this.setState({ PricesLevels: PricesLevels })
        this.pagination()

    }

    contains(parametro, busqueda) {
        if (parametro && busqueda) {
            return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
        }
        return false
    }

    searchPriceMargin = e => {
        const checkboxList = document.getElementsByClassName('PricesLevels')
        let PricesLevels = []
        for (const PriceLevel of checkboxList) {
            if (PriceLevel.checked) {
                PricesLevels.push(PriceLevel.value)
            }
        }

        let search = e;
        this.setState({ textFilter: search })
        if (search) {
            let Products = this.state.Products.slice(this.state.firstIndex, this.state.lastIndex).filter((item) => {
                if (((
                    this.contains(item.ItemCode, search) ||
                    this.contains(item.ProductLine, search) ||
                    this.contains(item.ItemCodeDesc, search)

                ))
                ) {
                    return item
                } else {
                    return null
                }
            });
            let temporalProducts = []
            for (const Item of Products) {
                let newPricesLevels = []
                for (const Level of PricesLevels) {
                    const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                    if (index !== -1) {
                        newPricesLevels.push(Item.PricesLevels[index])
                    }
                }

                temporalProducts.push({
                    ItemCode: Item.ItemCode,
                    ItemCodeDesc: Item.ItemCodeDesc,
                    ProductLine: Item.ProductLine,
                    UnitCost: Item.UnitCost,
                    Change: Item.Change,
                    PricesLevels: newPricesLevels,
                    LastDueDate: Item.LastDueDate
                })
            }
            this.setState({ ProductsFilter: temporalProducts });
        } else {
            let Products = this.state.Products.slice(this.state.firstIndex, this.state.lastIndex)
            let temporalProducts = []
            for (const Item of Products) {
                let newPricesLevels = []
                for (const Level of PricesLevels) {
                    const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                    if (index !== -1) {
                        newPricesLevels.push(Item.PricesLevels[index])
                    }
                }

                temporalProducts.push({
                    ItemCode: Item.ItemCode,
                    ItemCodeDesc: Item.ItemCodeDesc,
                    ProductLine: Item.ProductLine,
                    UnitCost: Item.UnitCost,
                    Change: Item.Change,
                    PricesLevels: newPricesLevels,
                    LastDueDate: Item.LastDueDate
                })
            }
            this.setState({ ProductsFilter: temporalProducts });
        }


    }

    OrderPriceMargins(option) {
        var temporal = this.state.ProductsFilter
        switch (option) {
            case "ItemCode":
                temporal = OrderArray(temporal, "ItemCode", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "ProductLine":
                temporal = OrderArray(temporal, "ProductLine", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            case "UnitCost":
                temporal = OrderArray(temporal, "UnitCost", this.state.flag)
                this.setState({ ProductsFilter: temporal, flag: !this.state.flag })
                break;
            default:
                break;
        }
    }

    OrderByPriceLevel(position, key) {
        var arreglo = this.state.ProductsFilter
        var l = arreglo.length

        if (this.state.flag) {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) > (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        } else {
            for (let i = 0; i < l; i++) {
                for (let j = 0; j < l - 1 - i; j++) {
                    if ((arreglo[j].PricesLevels[position][key] === '-' ? '0' : arreglo[j].PricesLevels[position][key]) < (arreglo[j + 1].PricesLevels[position][key] === '-' ? '0' : arreglo[j + 1].PricesLevels[position][key])) {
                        [arreglo[j], arreglo[j + 1]] = [arreglo[j + 1], arreglo[j]];
                    }
                }
            }
        }

        this.setState({ ProductsFilter: arreglo, flag: !this.state.flag })
    }

    calculateNewPrice(e) {
        let id = e.target.id.split('_')

        if (id.length === 3) {
            let temporal = this.state.ProductsFilter
            let temporalG = this.state.Products
            const index = getIndexElement(temporal, 'ItemCode', id[1])
            const index2 = getIndexElement(temporalG, 'ItemCode', id[1])
            if (index !== -1 && index2 !== -1) {
                let Element = temporal[index]
                let Element2 = temporalG[index2]
                Element.Change = true
                Element2.Change = true
                const indexPrice = getIndexElement(Element.PricesLevels, 'PriceLevel', id[2])
                const indexPrice2 = getIndexElement(Element2.PricesLevels, 'PriceLevel', id[2])
                if (indexPrice !== -1 && indexPrice2 !== -1) {
                    let temporalPrices = Element.PricesLevels[indexPrice]
                    let UnitCost = Element.UnitCost
                    let UnitPrice = Number(e.target.value)
                    temporalPrices.NewLevelCost = Number(e.target.value)
                    if ((Number(UnitPrice)) > 0) {
                        temporalPrices.NewRealMargin = ((Number(UnitPrice) - Number(UnitCost)) / (Number(UnitPrice))) * 100
                    } else {
                        temporalPrices.NewRealMargin = 0
                    }


                    Element.PricesLevels[indexPrice] = temporalPrices
                    Element2.PricesLevels[indexPrice2] = temporalPrices
                }
                temporal[index] = Element
                temporalG[index2] = Element2
                this.setState({ ProductsFilter: temporal, Products: temporalG })

            }
        }
    }


    // checkFilter(id, element) {
    //     //console.log("id:", id, " elemento:", element)
    //     const checkbox = document.getElementById(id);
    //     let count = 0
    //     if (element.Level === '0' && checkbox.checked === true) {
    //         const checkboxList = document.getElementsByClassName('PricesLevels')
    //         for (const checkbox of checkboxList) {
    //             checkbox.checked = true;
    //             count++
    //         }

    //     } else if (element.Level === '0' && checkbox.checked === false) {
    //         const checkboxList = document.getElementsByClassName('PricesLevels')
    //         for (const checkbox of checkboxList) {
    //             checkbox.checked = false;

    //         }

    //     } else {

    //         let cond = true
    //         const checkboxList = document.getElementsByClassName('PricesLevels')
    //         // for (const checkbox of checkboxList) {
    //         //     if ((!checkbox.checked) && (checkbox.id !== 'CheckChangeMarginPrice0')) {
    //         //         cond = false
    //         //         break
    //         //     }
    //         // }
    //         // for (const checkbox of checkboxList) {
    //         //     if (checkbox.checked && checkbox.id !== 'CheckChangeMarginPrice0') {
    //         //         count++
    //         //     }
    //         // }

    //         // let all = document.getElementById('CheckChangeMarginPrice0')
    //         // if (all) {
    //         //     all.checked = cond
    //         // }


    //     }
    //     this.setState({ minwidth: (120 * count) + 'vh' })
    //     this.FilterBySelectedPricesLevels()
    // }

    FilterBySelectedPricesLevels() {
        const checkboxList = document.getElementsByClassName('PricesLevels')
        let PricesLevels = []
        for (const PriceLevel of checkboxList) {
            if (PriceLevel.checked) {
                PricesLevels.push(PriceLevel.value)
            }
        }
        let temporalHeaders = []
        for (const Level of PricesLevels) {
            const index = getIndexElement(this.state.AuxTableHeaders, 'Level', Level)
            if (index !== -1) {
                temporalHeaders.push(this.state.AuxTableHeaders[index])
            }
        }

        let temporalProducts = []
        for (const Item of this.state.Products.slice(this.state.firstIndex, this.state.lastIndex)) {
            let newPricesLevels = []
            for (const Level of PricesLevels) {
                const index = getIndexElement(Item.PricesLevels, 'PriceLevel', String(Level))

                if (index !== -1) {
                    newPricesLevels.push(Item.PricesLevels[index])
                }
            }

            temporalProducts.push({
                ItemCode: Item.ItemCode,
                ItemCodeDesc: Item.ItemCodeDesc,
                ProductLine: Item.ProductLine,
                UnitCost: Item.UnitCost,
                Change: Item.Change,
                PricesLevels: newPricesLevels,
                LastDueDate: Item.LastDueDate
            })
        }



        this.setState({ TableHeaders: temporalHeaders, ProductsFilter: temporalProducts })
        this.searchPriceMargin(this.state.textFilter)

    }

    pagination() {
        const temp = []
        for (let i = 1; i <= Math.ceil(this.state.Products.length / this.state.ProductsPerPage); i++) {
            temp.push(i)
        }
        //console.log("hola temp:",temp,"length",this.state.ProductsFilter)
        this.setState({ pageNumers: temp })
    }

    // Exclude the already added items
    getNotAddedItemList() {
        this.setState({addItemModal: true})
        const allItems = this.state.Products
        const exceptionItems = []

        // Remove the current exception items from the complete item list
        const filterItems = allItems.filter(item => 
            exceptionItems.some(exceptionItem =>  item['itemCode'] === exceptionItem['itemCode']))
        
        return filterItems

    }

    extractItems(itemList) {
        // Get current list
        const exceptionItems = []
        // Filter exception items from the complete list
        const filterItems = exceptionItems.filter(exceptionItem => 
            itemList.some(item =>  exceptionItem['itemCode'] === item['itemCode']))
        
        return filterItems
    }

    // Add a new exception items
    async addNewItem(item) {
        Swal.fire({
            title: `Are you sure to add ${item.itemCode}?`,
            icon: 'warning',
            confirmButtonColor: '#30d5c8',
            cancelButtonColor: '#a8b3c7',
            showCancelButton: true,
            confirmButtonText: 'Add',
            cancelButtonText: 'Cancel',
        }).then(async (result) => {
            if (result.isConfirmed) {
                this.setState({addItemModal: false})
                // Update exception item list
                const { Products, ExcludedItems }= this.state
                console.log('item before insert', item)
                console.log('exception list', Products)
                this.loadExceptionItems()
                // Remove from the adding list
                const updateExcludedItems = ExcludedItems.filter(excludedItem => excludedItem.itemCode !== item.ItemCode)
                this.setState({ExcludedItems: updateExcludedItems})
            }
        })
    }

    handleModalClose() {
        this.setState({ addItemModal: false })
    }

    render() {
        const minWidth = this.state.minwidth
        return (
            <div className='conteiner'>
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Calculate New Price Margins</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please click on Load Data button.</p>
                </div>
                <div>
                    <button onClick={() => this.getNotAddedItemList()}>Add new item</button>
                    <div>
                        <div className='col-12 tableFixHead'>
                            <table className={'table align-middle table-hover'} style={{ minWidth }}>
                                <thead className='thead'>
                                    <tr className='text-light text-center bg-dark'>
                                        <th colSpan={5} className='sticky-col-head colfix' >
                                            <div className='row'>
                                                <div className=' col-2 ml-auto' onClick={() => this.OrderPriceMargins("ItemCode")}><div className='row'><div className='col-12'>Item Code</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div></div></div>
                                                <div className=' col-3' onClick={() => this.OrderPriceMargins("ProductLine")}><div className='row'><div className='col-12'>Product Line</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div></div></div>
                                                <div className=' col-4'><div className='row'><div className='col-12'>Description</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div></div></div>
                                                <div className=' col-1'></div>
                                                <div className=' col-2 mr-auto' onClick={() => this.OrderPriceMargins("UnitCost")}><div className='row'><div className='col-12'>Last Unit Cost</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div></div></div>
                                            </div>
                                        </th>
                                        {this.state.TableHeaders.map((head, h) => (
                                            <React.Fragment key={h} >
                                                <th className={((h + 1) % 2 === 1 ? 'backgroundBlue' : 'backgroundGreen') + ' '}></th>
                                                <th className={((h + 1) % 2 === 1 ? 'backgroundBlue' : 'backgroundGreen') + ' '} onClick={() => this.OrderByPriceLevel(h, "LevelCost")}><div className='row'><div className='col-12'>{head.Title1}</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div> </div></th>
                                                <th className={((h + 1) % 2 === 1 ? 'backgroundBlue' : 'backgroundGreen') + ' '} onClick={() => this.OrderByPriceLevel(h, "RealMargin")}><div className='row'><div className='col-12'>{head.Title2}</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div> </div></th>
                                                <th className={((h + 1) % 2 === 1 ? 'backgroundBlue' : 'backgroundGreen') + ' '} onClick={() => this.OrderByPriceLevel(h, "LevelCost")}><div className='row'><div className='col-12'>{head.Title3}</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div> </div></th>
                                                <th className={((h + 1) % 2 === 1 ? 'backgroundBlue' : 'backgroundGreen') + ' '} onClick={() => this.OrderByPriceLevel(h, "RealMargin")}><div className='row'><div className='col-12'>{head.Title4}</div><div className='col-12'><BsFileArrowUpFill /><BsFileArrowDownFill /></div> </div></th>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className='tbody'>
                                    {
                                        this.state.ProductsFilter.map((item, i) => (
                                            <tr className={(item.Change ? 'bg-warning' : 'bg-light')} key={i}>
                                                <td colSpan={5} className={(item.Change ? ' sticky-col bg-warning' : ' sticky-col bg-light')}>
                                                    <div className={'row '}>
                                                    <div className='col-2  positionStartText'>{item.ItemCode}</div>
                                                    <div className='col-3 align-middle positionStartText'>{item.ProductLine}</div>
                                                    <div className='col-4 align-middle positionStartText'>{item.ItemCodeDesc}</div>
                                                    <div className='col-1 pt-3 align-middle positionEndText'>$</div>
                                                    <div className='col-2 pt-3 align-middle  positionEndText'>{NumberFormat(pricesFormat(item.UnitCost))}</div>
                                                    </div>
                                                </td>
                                            { item.PricesLevels.map((price) => (
                                                <React.Fragment key={item.ItemCode + '_' + price.PriceLevel}>
                                                    <td className='text-end '>{price.LevelCost !== '-' ? '$' : '$'}</td>
                                                    <td className='text-end '>
                                                        {price.LevelCost !== '-' ? NumberFormat(pricesFormat(price.LevelCost)) : '0'}
                                                    </td>
                                                    <td className='text-center  '>
                                                        {price.RealMargin !== '-' ? NumberFormat(pricesFormat(price.RealMargin)) + "%" : '0.00%'}
                                                    </td>
                                                    <td className='text-center'>
                                                        <div className="input-group  flex-nowrap">
                                                            <span className="input-group-text">$</span>
                                                            <input onChange={(e) => this.calculateNewPrice(e, price.LevelCost)} type="number" step={0.05} autoComplete='off' defaultValue={pricesFormat(price.NewLevelCost)} className="form-control text-center" id={'calculatePriceMargin_' + item.ItemCode + '_' + price.PriceLevel} />
                                                        </div>
                                                    </td>
                                                    <td className='text-center  '>
                                                        {price.NewRealMargin !== '-' ? NumberFormat(pricesFormat(price.NewRealMargin)) + "%" : '0.00%'}
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                <SmallModal centered={true} size={'xl'} title={'Add New Item'} show={this.state.addItemModal} close={(modal = "addItemModal") => this.handleModalClose(modal)}>
                    <div className='col-sm-12 tableFixHead'>
                        <table className='table table-striped align-middle table-hover'>
                            <thead>
                            <tr>
                                <th>Item Code</th>
                                <th>Product Line</th>
                                <th>Name</th>
                                <th>Level 1</th>
                                <th>Level 2</th>
                                <th>Level 3</th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.ExcludedItems.map((item, i) => (
                                <tr key={i} className=''>
                                    <td className='text-center' style={{ cursor: 'pointer' }}>{item.itemCode}</td>
                                    <td className='text-start' style={{ cursor: 'pointer' }}>{item.ProductLine}</td>
                                    <td className='text-start' style={{ cursor: 'pointer' }}>{item.ItemCodeDesc}</td>
                                    {
                                        Array.from({ length: 3 }, (_, index) => {
                                            const price = item.PricesLevels[index];
                                            return (
                                                <td key={index} className='text-center' style={{ cursor: 'pointer' }}>
                                                    {price ? price.LevelCost : '-'}
                                                </td>
                                            );
                                        })
                                    }
                                    <td className='text-center' style={{ cursor: 'pointer' }} onClick={() => this.addNewItem(item)}><button>Add</button></td>
                                </tr>
                                ))
                            }
                            </tbody>
                        </table>
                    </div>
                </SmallModal>
            </div>
        )
    }
}
